import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Observable, Subscription, debounceTime, distinctUntilChanged, fromEvent } from "rxjs";
import { PersonRoleEnum } from '../../Models/OtherClasses';
import { AuthService } from '../../RoutingAuth/auth.service';
import { DateTime } from 'luxon';

@Component({
	selector: 'SideMenu',
	templateUrl: 'SideMenu.html',

})
export class SideMenuComponent implements OnInit, OnDestroy {



	constructor(
		private renderer: Renderer2,
		private authService: AuthService,
	) {
	}

	//Resize stuff borrowed from here: https://stackoverflow.com/questions/35527456/angular-window-resize-event
	resizeObservable$: Observable<Event>
	resizeSubscription$: Subscription
	manualResizeSubscription$: Subscription
	authSubscription: Subscription;
	companyChangeSubscription: Subscription;

	isManuallyClosed: boolean = false;

	customerID: System.Guid = '';
	isCustomer: boolean = false;
	isMasterCustomer = false;
	isAccountAdmin = false;
	isWarehouseCustomer: boolean = false;

	isDispatch: boolean = false;
	isDriver: boolean = false;
	isWarehouse: boolean = false;
	isAdmin: boolean = false;
	isEmployee: boolean = false;
	isSuperAdmin: boolean = false;
	compLogo = '';
	get showNewOrders(): boolean {
		if (this.isDriver) {
			if (!this.isDispatch && !this.isAdmin) {
				return false;
			}
		}
		return true;
	}

	get showOrdersList(): boolean {
		return this.showNewOrders && this.isEmployee;
	}
	ngOnInit() {
		this.compLogo = this.authService.configData.defaultLogo;
		this.isManuallyClosed = this.authService.configData.getSavedSetting('menuClosed', 'SideMenu');
		if (!this.isManuallyClosed) {
			this.setBodyClassesBySize();
		} else {
			this.toggleMenuOpenClosedState();
		}
		this.manualResizeSubscription$ = this.authService.configData.whenmenuChangedManually().subscribe(obj => {
			this.toggleMenuOpenClosedState();
		});
		this.resizeObservable$ = fromEvent(window, 'resize')
		this.resizeSubscription$ = this.resizeObservable$.pipe(
			debounceTime(200),
			distinctUntilChanged(),
		)
			.subscribe(evt => {
				if (!this.isManuallyClosed) {
					this.setBodyClassesBySize();
				}
			});

		var thisHolder = this;
		this.authSubscription = this.authService.authNavStatus$.subscribe((isAuthed: boolean) => {
			thisHolder.setPermissions(isAuthed);
		});
		this.companyChangeSubscription = this.authService.companyChanged$.subscribe((isAuthed: boolean) => {
			this.compLogo =
				this.authService.configData.apiBaseUrl()
				+ "api/v1/Company/Logo/"
				+ this.authService.configData.companyID
				+ '?ex='
				+ DateTime.local().millisecond.toString();;
		});
	}

	setPermissions(isAuthed: boolean) {
		this.compLogo =
			this.authService.configData.apiBaseUrl()
			+ "api/v1/Company/Logo/"
			+ this.authService.configData.companyID;

		this.isWarehouseCustomer = false;
		this.isDispatch = false;
		this.isDriver = false;
		this.isWarehouse = false;
		this.isAdmin = false;

		this.isSuperAdmin = this.authService.configData.IsUserInRole(PersonRoleEnum.SUPERADMIN);
		this.isCustomer = this.authService.configData.isCustomerUser();
		this.customerID = this.authService.configData.customerID();
		this.isMasterCustomer = this.authService.configData.isMasterCustomer();
		this.isAccountAdmin = this.authService.configData.isAccountAdmin();
		this.isEmployee = this.authService.configData.isEmployee();
		if (this.isCustomer) {
			this.isWarehouseCustomer = this.authService.configData.isWarehouseCustomer();
		} else if (this.isEmployee) {
			this.isAdmin = this.authService.configData.IsUserInRole(PersonRoleEnum.ADMIN);
			this.isWarehouse = this.isAdmin || this.authService.configData.IsUserInRole(PersonRoleEnum.WAREHOUSE);
			this.isDriver = this.authService.configData.IsUserInRoleInternal(PersonRoleEnum.DRIVER, false);
			this.isDispatch = this.isAdmin || this.authService.configData.IsUserInRole(PersonRoleEnum.DISPATCH);
		}
	}

	toggleBodyClass(className: string): boolean {
		if (document.body.classList.contains(className)) {
			this.renderer.removeClass(document.body, className);
			return false;
		} else {
			this.renderer.addClass(document.body, className);
			return true;
		}
	}
	toggleMenuOpenClosedState() {
		var width = document.body.clientWidth;
		if (width < 991.98) {
			this.toggleBodyClass('navSmall');
			var isSmall = this.toggleBodyClass('navClosed');
			this.authService.configData.setSavedSetting('menuClosed', 'SideMenu', isSmall);
		} else {
			this.renderer.removeClass(document.body, 'navClosed'); //Just in case it's there from before
			var isSmall = this.toggleBodyClass('navSmall');
			this.authService.configData.setSavedSetting('menuClosed', 'SideMenu', isSmall);
		}
	}
	setBodyClassesBySize() {
		var width = document.body.clientWidth;
		if (width <= 575.98) {
			this.renderer.removeClass(document.body, 'navSmall');
			this.renderer.addClass(document.body, 'navClosed');
		} else if (width > 575.98 && width < 991.98) {
			this.renderer.addClass(document.body, 'navSmall');
			this.renderer.removeClass(document.body, 'navClosed');
		} else {
			this.renderer.removeClass(document.body, 'navSmall');
			this.renderer.removeClass(document.body, 'navClosed');
		}
	}



	ngOnDestroy() {
		this.resizeSubscription$.unsubscribe();
		this.manualResizeSubscription$.unsubscribe();
		this.authSubscription.unsubscribe();
		this.companyChangeSubscription.unsubscribe();
	}

}
